module.exports = __webpack_public_path__ + "static/media/pager-image-small.8fca20ef.jpg";